var exports = {
  "gP": "EmbedVideo.module__videoOverlay___MUVhSW",
  "yH": "EmbedVideo.module__playButtonWrapper___MUVhSW",
  "SK": "EmbedVideo.module__thumbnailPlaceholder___MUVhSW",
  "aO": "EmbedVideo.module__thumbHashPlaceholder___MUVhSW",
  "mZ": "EmbedVideo.module__metadataProbe___MUVhSW",
  "tN": "EmbedVideo.module__blurContainer___MUVhSW",
  "rj": "EmbedVideo.module__blurContent___MUVhSW",
  "UF": "EmbedVideo.module__blurInner___MUVhSW",
  "Y3": "EmbedVideo.module__blurThumbnail___MUVhSW",
  "il": "EmbedVideo.module__mediaContainer___MUVhSW",
  "AA": "EmbedVideo.module__mobileContainer___MUVhSW",
  "SY": "EmbedVideo.module__videoPlayerWrapper___MUVhSW",
  "s": "EmbedVideo.module__videoPlayerBlock___MUVhSW",
  "Qh": "EmbedVideo.module__videoPlayerFill___MUVhSW",
  "hz": "EmbedVideo.module__inlineVideo___MUVhSW",
  "nD": "EmbedVideo.module__inlineMuteButton___MUVhSW",
};

module.exports = exports;
